import type { MembershipsDirectMessagesApiClient } from '@fourthwall/services/dist/MembershipsDirectMessagesApiClient'

import type { FormValues } from './types'

export const getUpdateDirectMessagesPayload = (
  formValues: FormValues,
): Parameters<typeof MembershipsDirectMessagesApiClient.updateDirectMessagesSettings>[number] => {
  const { messagesEnabled, tipsEnabled, minTipEnabled, minTipAmount } = formValues

  if (!messagesEnabled) {
    return {
      directMessages: null,
    }
  }

  if (!tipsEnabled) {
    return {
      directMessages: {
        tips: {
          type: 'Disable',
        },
      },
    }
  }

  if (tipsEnabled && !minTipEnabled) {
    return {
      directMessages: {
        tips: {
          type: 'Enable',
        },
      },
    }
  }

  if (tipsEnabled && minTipEnabled && minTipAmount) {
    return {
      directMessages: {
        tips: {
          type: 'Enable',
          minimumAmount: minTipAmount * 100,
        },
      },
    }
  }

  return {}
}
